function PillArchives({ label, isActive, value, handleClick }) {
  return (
    <div onClick={() => handleClick(value)} className={` year ${isActive ? 'selected' : ''}`}>
      {label}
    </div>
  );
}

export default PillArchives;
